module.exports = __webpack_public_path__ + "static/media/NIC.56b0bc2f.svg";